import React, { FC } from 'react';
import { LayoutCarousel } from '@silverfort/sf-components';
import IspmTopLists from '../../TopLists/IspmTopLists';

const IspmTopListsWidget: FC = () => {
    return <LayoutCarousel contentClassName="-mx-4 -my-4 items-start" pages={<IspmTopLists />} title="Top Lists" />;
};

export default IspmTopListsWidget;
